import { c as _c } from "react/compiler-runtime";
import { PROFILE_PROXY_AVAILABLE_ACTIONS } from "@/entities/IProxy";
import { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import ProxyCreateActionSelectTypeItem from "./ProxyCreateActionSelectTypeItem";
export default function ProxyCreateActionSelectType(t0) {
  const $ = _c(14);
  const {
    currentActions,
    setSelectedActionType,
    onCancel
  } = t0;
  let t1;
  if ($[0] !== currentActions) {
    t1 = actionType => {
      if (!PROFILE_PROXY_AVAILABLE_ACTIONS.includes(actionType)) {
        return false;
      }
      switch (actionType) {
        case ApiProfileProxyActionType.AllocateRep:
          {
            return !currentActions.some(_temp);
          }
        case ApiProfileProxyActionType.AllocateCic:
          {
            return !currentActions.some(_temp2);
          }
        case ApiProfileProxyActionType.CreateWave:
          {
            return !currentActions.some(_temp3);
          }
        case ApiProfileProxyActionType.ReadWave:
          {
            return !currentActions.some(_temp4);
          }
        case ApiProfileProxyActionType.CreateDropToWave:
          {
            return !currentActions.some(_temp5);
          }
        case ApiProfileProxyActionType.RateWaveDrop:
          {
            return !currentActions.some(_temp6);
          }
        default:
          {
            assertUnreachable(actionType);
            return false;
          }
      }
    };
    $[0] = currentActions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isActionAvailable = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Object.values(ApiProfileProxyActionType);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isActionAvailable) {
    t3 = t2.filter(isActionAvailable);
    $[3] = isActionAvailable;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const availableActions = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">Select action type</p>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== availableActions || $[7] !== setSelectedActionType) {
    t5 = availableActions.map(actionType_0 => <ProxyCreateActionSelectTypeItem key={actionType_0} actionType={actionType_0} setSelectedActionType={setSelectedActionType} />);
    $[6] = availableActions;
    $[7] = setSelectedActionType;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onCancel) {
    t6 = onCancel && <li><button onClick={onCancel} type="button" className="tw-flex tw-items-center tw-justify-center tw-relative tw-bg-iron-800 tw-px-3.5 tw-py-2.5 tw-text-sm tw-leading-5 tw-font-semibold tw-text-white tw-border tw-border-solid tw-border-iron-700 tw-rounded-lg hover:tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out">Cancel</button></li>;
    $[9] = onCancel;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div>{t4}<ul className="tw-mt-2 sm:tw-mt-4 tw-list-none tw-pl-0 tw-flex tw-items-center tw-gap-x-3">{t5}{t6}</ul></div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp6(action) {
  return action.action_type === ApiProfileProxyActionType.RateWaveDrop;
}
function _temp5(action_0) {
  return action_0.action_type === ApiProfileProxyActionType.CreateDropToWave;
}
function _temp4(action_1) {
  return action_1.action_type === ApiProfileProxyActionType.ReadWave;
}
function _temp3(action_2) {
  return action_2.action_type === ApiProfileProxyActionType.CreateWave;
}
function _temp2(action_3) {
  return action_3.action_type === ApiProfileProxyActionType.AllocateCic;
}
function _temp(action_4) {
  return action_4.action_type === ApiProfileProxyActionType.AllocateRep;
}